import type { FunctionComponent } from 'react';

/**
 * Common badge component for IssueItems
 */
const IssueItemBadge: FunctionComponent = ({ children }) => (
  <div className="issue-item__badge">
    {children}
  </div>
);

export default IssueItemBadge;
